var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFb = function SvgFb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.9,
    y: 2.9,
    width: 18.2,
    height: 18.2,
    rx: 1.3,
    stroke: "#000",
    strokeWidth: 1.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6h-1.91c-.843 0-1.652.395-2.249 1.098-.597.704-.932 1.657-.932 2.652V12H11v3h1.91v6h2.544v-6h1.91L18 12h-2.546V9.75c0-.199.068-.39.187-.53.12-.141.281-.22.45-.22H18V6Z",
    fill: "#000"
  })));
};
export { SvgFb as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxyZWN0IHg9IjIuOSIgeT0iMi45IiB3aWR0aD0iMTguMiIgaGVpZ2h0PSIxOC4yIiByeD0iMS4zIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjEuOCIvPg0KPHBhdGggZD0iTTE4IDZIMTYuMDkwOUMxNS4yNDcgNiAxNC40Mzc3IDYuMzk1MDkgMTMuODQxIDcuMDk4MzVDMTMuMjQ0MyA3LjgwMTYxIDEyLjkwOTEgOC43NTU0NCAxMi45MDkxIDkuNzVWMTJIMTFWMTVIMTIuOTA5MVYyMUgxNS40NTQ1VjE1SDE3LjM2MzZMMTggMTJIMTUuNDU0NVY5Ljc1QzE1LjQ1NDUgOS41NTEwOSAxNS41MjE2IDkuMzYwMzIgMTUuNjQwOSA5LjIxOTY3QzE1Ljc2MDMgOS4wNzkwMiAxNS45MjIxIDkgMTYuMDkwOSA5SDE4VjZaIiBmaWxsPSJibGFjayIvPg0KPC9zdmc+DQo=";